import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

/** 1. GET the list of Master Operations (MOIDs) that can have a PO upload document amount limit */
export const getUploadDocsMoids = () =>
    axios.get(`${base}/Accounts/Getuploaddocsmoids`);

/** 2. GET the currently configured amount limit for a specific MOID */
export const getMoidPosLimitAmount = (code) =>
    axios.get(`${base}/Accounts/GetupdmoidposlimitAmount`, { params: { code } });

/** 3. GET all saved MOID-wise upload amount limits (grid) */
export const getPOMOIDwiseUploadLimit = () =>
    axios.get(`${base}/Accounts/ViewPOMOIDwiseUploadLimit`);

/** 4. POST save/update the upload amount limit for a MOID */
export const savePosUploadAmountLimit = ({ code, value, Createdby }) =>
    axios.post(`${base}/Accounts/SaveposuploadamountLimitDetails`, { code, value, Createdby });
